import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertDialog, DialogNotes } from '@lyearn/molecules';

import { BaseLimitedEditingModalProps } from './types';

function BaseLimitedEditingModal(props: BaseLimitedEditingModalProps) {
  const { t } = useTranslation();
  const { content, description, onClose } = props;

  return (
    <AlertDialog
      header={{ title: t('QuizCreator:LimitedEditingModal.Title'), description }}
      primaryAction={{ label: t('Common:GotIt'), onClick: onClose }}
      secondaryAction="hidden"
      onClose={onClose}>
      <DialogNotes items={content} />
    </AlertDialog>
  );
}

export default BaseLimitedEditingModal;
